import { Link } from 'react-router-dom'
import { Container } from '@/components/layout/Container'
import { ProductGrid } from '@/components/sections/ProductGrid'
import { Button } from '@/components/ui/Button'
import type { Perfume } from '@/types'
import type { PromoModules } from '@/lib/api'

interface MidnightMarketProps {
  promo?: PromoModules['midnightMarket']
  products: Perfume[]
}

export function MidnightMarket({ promo, products }: MidnightMarketProps) {
  if (!promo?.enabled) return null
  if (promo.active === false) return null

  const slugs = new Set((promo.productSlugs ?? []).filter(Boolean))
  const picked = slugs.size > 0 ? products.filter((p) => slugs.has(p.id)) : products.slice(0, 6)

  if (picked.length === 0) return null

  return (
    <section className="border-y border-ink/10 bg-deep py-16 lg:py-24">
      <Container>
        <div className="mb-10 flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-end">
          <div>
            <p className="mb-2 text-xs uppercase tracking-[0.25em] text-wd-orange">Limited window</p>
            <h2 className="font-display text-display-lg normal-case text-paper">
              {promo.title || 'Midnight market'}
            </h2>
            <p className="mt-2 max-w-md text-sm text-paper/70">
              {promo.subtitle || 'A quiet window of limited picks, refreshed nightly.'}
            </p>
          </div>
          <Link to="/shop">
            <Button variant="secondary">Shop all</Button>
          </Link>
        </div>
        <ProductGrid perfumes={picked} />
      </Container>
    </section>
  )
}
